module.exports = __webpack_public_path__ + "static/media/microsoft-icon.770bcbea.svg";